<form (submit)="onNext()" class="submitted" autocomplete="off">
  <app-page-title>
    {{ headerTitleKey | translate }}
  </app-page-title>

  <a [class]="pageType + '-page-other-method'" (click)="navigateToOtherMethod()">
    {{ otherMethodKey | translate }}
  </a>

  <h5 class="phone-confirmation-title">{{ 'login.v2.is_it_yours_msisdn' | translate }}</h5>

  <app-msisdn-input [passedFormControl]="formControl"
                    [autoPrependWithPlus]="false"
                    [showLabel]="false"/>

  <div class="login-page-input-errors">
    <app-input-errors [hidden]="!formErrors.error"
                      translationKey="errors.phone_confirmation"
                      [errorsForField]="formErrors"/>
  </div>

  <button [disabled]="!formControl.valid" class="btn btn-raised btn-block btn-primary">
    <span>{{ 'generic.button_next' | translate }}</span>
  </button>

  <button [routerLink]="['..']" class="btn btn-raised btn-block btn-default">
    <span>{{ 'generic.button_back' | translate }}</span>
  </button>
</form>
